import {
  useMutation,
  useQuery
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  AccountDirectSalesListingResponseDto,
  AccountExistResponseDto,
  AccountOrdersBuyerResponseDto,
  AdminPasswordResetBodyDto,
  AdminPasswordResetResponseDto,
  AdminUserResponseWithGrantType,
  ApiAccountAuctionsBuyerParams,
  ApiAccountAuctionsSellerParams,
  ApiAccountDirectSalesBuyerParams,
  ApiAccountDirectSalesSellerParams,
  ApiAccountExistParams,
  ApiAccountOrdersBuyerParams,
  ApiConfirmEmailChangeParams,
  AuctionsListingResponseDto,
  BackendErrorEntity,
  ChangeAccountEmailDto,
  ChangeMarketingCommunicationsConsentDto,
  ChangePasswordDto,
  ChangePasswordResponseDto,
  CompleteOnboardingSessionBodyDto,
  CompleteOnboardingSessionResponseDto,
  DirectSalesListingResponseDto,
  PasswordResetDto,
  RequestAdminPasswordResetBodyDto,
  RequestPasswordResetDto,
  UpdateAccountBodyDto,
  UpdateAccountCompanyBodyDto,
  UpdateAccountCompanyResponseDto,
  UpdateAccountDto,
  UpdateAccountResponseDto,
  UserEntity
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiRequestPasswordReset = (
    requestPasswordResetDto: MaybeRef<RequestPasswordResetDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      requestPasswordResetDto = unref(requestPasswordResetDto);
      
      return fetchApiInstance<void>(
      {url: `/account/requestPasswordReset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestPasswordResetDto
    },
      options);
    }
  


export const getApiRequestPasswordResetMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiRequestPasswordReset>>, TError,{data: BodyType<RequestPasswordResetDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiRequestPasswordReset>>, TError,{data: BodyType<RequestPasswordResetDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiRequestPasswordReset>>, {data: BodyType<RequestPasswordResetDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiRequestPasswordReset(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiRequestPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof apiRequestPasswordReset>>>
    export type ApiRequestPasswordResetMutationBody = BodyType<RequestPasswordResetDto>
    export type ApiRequestPasswordResetMutationError = ErrorType<BackendErrorEntity>

    export const useApiRequestPasswordReset = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiRequestPasswordReset>>, TError,{data: BodyType<RequestPasswordResetDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiRequestPasswordReset>>,
        TError,
        {data: BodyType<RequestPasswordResetDto>},
        TContext
      > => {

      const mutationOptions = getApiRequestPasswordResetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiPasswordReset = (
    passwordResetDto: MaybeRef<PasswordResetDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      passwordResetDto = unref(passwordResetDto);
      
      return fetchApiInstance<UserEntity>(
      {url: `/account/passwordReset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: passwordResetDto
    },
      options);
    }
  


export const getApiPasswordResetMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPasswordReset>>, TError,{data: BodyType<PasswordResetDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiPasswordReset>>, TError,{data: BodyType<PasswordResetDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiPasswordReset>>, {data: BodyType<PasswordResetDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiPasswordReset(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof apiPasswordReset>>>
    export type ApiPasswordResetMutationBody = BodyType<PasswordResetDto>
    export type ApiPasswordResetMutationError = ErrorType<BackendErrorEntity>

    export const useApiPasswordReset = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPasswordReset>>, TError,{data: BodyType<PasswordResetDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiPasswordReset>>,
        TError,
        {data: BodyType<PasswordResetDto>},
        TContext
      > => {

      const mutationOptions = getApiPasswordResetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiUpdateAccountPersonalData = (
    updateAccountDto: MaybeRef<UpdateAccountDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      updateAccountDto = unref(updateAccountDto);
      
      return fetchApiInstance<UserEntity>(
      {url: `/account/personalData`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateAccountDto
    },
      options);
    }
  


export const getApiUpdateAccountPersonalDataMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateAccountPersonalData>>, TError,{data: BodyType<UpdateAccountDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUpdateAccountPersonalData>>, TError,{data: BodyType<UpdateAccountDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUpdateAccountPersonalData>>, {data: BodyType<UpdateAccountDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiUpdateAccountPersonalData(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUpdateAccountPersonalDataMutationResult = NonNullable<Awaited<ReturnType<typeof apiUpdateAccountPersonalData>>>
    export type ApiUpdateAccountPersonalDataMutationBody = BodyType<UpdateAccountDto>
    export type ApiUpdateAccountPersonalDataMutationError = ErrorType<BackendErrorEntity>

    export const useApiUpdateAccountPersonalData = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateAccountPersonalData>>, TError,{data: BodyType<UpdateAccountDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUpdateAccountPersonalData>>,
        TError,
        {data: BodyType<UpdateAccountDto>},
        TContext
      > => {

      const mutationOptions = getApiUpdateAccountPersonalDataMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiChangePassword = (
    changePasswordDto: MaybeRef<ChangePasswordDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      changePasswordDto = unref(changePasswordDto);
      
      return fetchApiInstance<ChangePasswordResponseDto>(
      {url: `/account/changePassword`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: changePasswordDto
    },
      options);
    }
  


export const getApiChangePasswordMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiChangePassword>>, TError,{data: BodyType<ChangePasswordDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiChangePassword>>, TError,{data: BodyType<ChangePasswordDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiChangePassword>>, {data: BodyType<ChangePasswordDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiChangePassword(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof apiChangePassword>>>
    export type ApiChangePasswordMutationBody = BodyType<ChangePasswordDto>
    export type ApiChangePasswordMutationError = ErrorType<BackendErrorEntity>

    export const useApiChangePassword = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiChangePassword>>, TError,{data: BodyType<ChangePasswordDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiChangePassword>>,
        TError,
        {data: BodyType<ChangePasswordDto>},
        TContext
      > => {

      const mutationOptions = getApiChangePasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiChangeMarketingCommunicationsConsent = (
    changeMarketingCommunicationsConsentDto: MaybeRef<ChangeMarketingCommunicationsConsentDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      changeMarketingCommunicationsConsentDto = unref(changeMarketingCommunicationsConsentDto);
      
      return fetchApiInstance<void>(
      {url: `/account/changeMarketingCommunicationsConsent`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: changeMarketingCommunicationsConsentDto
    },
      options);
    }
  


export const getApiChangeMarketingCommunicationsConsentMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiChangeMarketingCommunicationsConsent>>, TError,{data: BodyType<ChangeMarketingCommunicationsConsentDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiChangeMarketingCommunicationsConsent>>, TError,{data: BodyType<ChangeMarketingCommunicationsConsentDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiChangeMarketingCommunicationsConsent>>, {data: BodyType<ChangeMarketingCommunicationsConsentDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiChangeMarketingCommunicationsConsent(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiChangeMarketingCommunicationsConsentMutationResult = NonNullable<Awaited<ReturnType<typeof apiChangeMarketingCommunicationsConsent>>>
    export type ApiChangeMarketingCommunicationsConsentMutationBody = BodyType<ChangeMarketingCommunicationsConsentDto>
    export type ApiChangeMarketingCommunicationsConsentMutationError = ErrorType<BackendErrorEntity>

    export const useApiChangeMarketingCommunicationsConsent = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiChangeMarketingCommunicationsConsent>>, TError,{data: BodyType<ChangeMarketingCommunicationsConsentDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiChangeMarketingCommunicationsConsent>>,
        TError,
        {data: BodyType<ChangeMarketingCommunicationsConsentDto>},
        TContext
      > => {

      const mutationOptions = getApiChangeMarketingCommunicationsConsentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiChangeAccountEmail = (
    changeAccountEmailDto: MaybeRef<ChangeAccountEmailDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      changeAccountEmailDto = unref(changeAccountEmailDto);
      
      return fetchApiInstance<void>(
      {url: `/account/changeEmail`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: changeAccountEmailDto
    },
      options);
    }
  


export const getApiChangeAccountEmailMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiChangeAccountEmail>>, TError,{data: BodyType<ChangeAccountEmailDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiChangeAccountEmail>>, TError,{data: BodyType<ChangeAccountEmailDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiChangeAccountEmail>>, {data: BodyType<ChangeAccountEmailDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiChangeAccountEmail(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiChangeAccountEmailMutationResult = NonNullable<Awaited<ReturnType<typeof apiChangeAccountEmail>>>
    export type ApiChangeAccountEmailMutationBody = BodyType<ChangeAccountEmailDto>
    export type ApiChangeAccountEmailMutationError = ErrorType<BackendErrorEntity>

    export const useApiChangeAccountEmail = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiChangeAccountEmail>>, TError,{data: BodyType<ChangeAccountEmailDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiChangeAccountEmail>>,
        TError,
        {data: BodyType<ChangeAccountEmailDto>},
        TContext
      > => {

      const mutationOptions = getApiChangeAccountEmailMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiConfirmEmailChange = (
    params: MaybeRef<ApiConfirmEmailChangeParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<string>(
      {url: `/account/confirmEmail`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiConfirmEmailChangeQueryKey = (params: MaybeRef<ApiConfirmEmailChangeParams>,) => {
    return ['account','confirmEmail', ...(params ? [params]: [])] as const;
    }

    
export const getApiConfirmEmailChangeQueryOptions = <TData = Awaited<ReturnType<typeof apiConfirmEmailChange>>, TError = ErrorType<BackendErrorEntity>>(params: MaybeRef<ApiConfirmEmailChangeParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiConfirmEmailChange>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiConfirmEmailChangeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiConfirmEmailChange>>> = () => apiConfirmEmailChange(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiConfirmEmailChange>>, TError, TData> 
}

export type ApiConfirmEmailChangeQueryResult = NonNullable<Awaited<ReturnType<typeof apiConfirmEmailChange>>>
export type ApiConfirmEmailChangeQueryError = ErrorType<BackendErrorEntity>



export function useApiConfirmEmailChange<TData = Awaited<ReturnType<typeof apiConfirmEmailChange>>, TError = ErrorType<BackendErrorEntity>>(
 params: MaybeRef<ApiConfirmEmailChangeParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiConfirmEmailChange>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiConfirmEmailChangeQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiAdminMe = (
    
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      
      
      return fetchApiInstance<AdminUserResponseWithGrantType>(
      {url: `/account/admin/me`, method: 'GET'
    },
      options);
    }
  

export const getApiAdminMeQueryKey = () => {
    return ['account','admin','me'] as const;
    }

    
export const getApiAdminMeQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminMe>>, TError = ErrorType<BackendErrorEntity>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAdminMe>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiAdminMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminMe>>> = () => apiAdminMe(requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminMe>>, TError, TData> 
}

export type ApiAdminMeQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminMe>>>
export type ApiAdminMeQueryError = ErrorType<BackendErrorEntity>



export function useApiAdminMe<TData = Awaited<ReturnType<typeof apiAdminMe>>, TError = ErrorType<BackendErrorEntity>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAdminMe>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiAdminMeQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiRequestAdminPasswordReset = (
    requestAdminPasswordResetBodyDto: MaybeRef<RequestAdminPasswordResetBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      requestAdminPasswordResetBodyDto = unref(requestAdminPasswordResetBodyDto);
      
      return fetchApiInstance<void>(
      {url: `/account/admin/requestPasswordReset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestAdminPasswordResetBodyDto
    },
      options);
    }
  


export const getApiRequestAdminPasswordResetMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiRequestAdminPasswordReset>>, TError,{data: BodyType<RequestAdminPasswordResetBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiRequestAdminPasswordReset>>, TError,{data: BodyType<RequestAdminPasswordResetBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiRequestAdminPasswordReset>>, {data: BodyType<RequestAdminPasswordResetBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiRequestAdminPasswordReset(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiRequestAdminPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof apiRequestAdminPasswordReset>>>
    export type ApiRequestAdminPasswordResetMutationBody = BodyType<RequestAdminPasswordResetBodyDto>
    export type ApiRequestAdminPasswordResetMutationError = ErrorType<BackendErrorEntity>

    export const useApiRequestAdminPasswordReset = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiRequestAdminPasswordReset>>, TError,{data: BodyType<RequestAdminPasswordResetBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiRequestAdminPasswordReset>>,
        TError,
        {data: BodyType<RequestAdminPasswordResetBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiRequestAdminPasswordResetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiAdminPasswordReset = (
    adminPasswordResetBodyDto: MaybeRef<AdminPasswordResetBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      adminPasswordResetBodyDto = unref(adminPasswordResetBodyDto);
      
      return fetchApiInstance<AdminPasswordResetResponseDto>(
      {url: `/account/admin/passwordReset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminPasswordResetBodyDto
    },
      options);
    }
  


export const getApiAdminPasswordResetMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminPasswordReset>>, TError,{data: BodyType<AdminPasswordResetBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminPasswordReset>>, TError,{data: BodyType<AdminPasswordResetBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminPasswordReset>>, {data: BodyType<AdminPasswordResetBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminPasswordReset(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminPasswordReset>>>
    export type ApiAdminPasswordResetMutationBody = BodyType<AdminPasswordResetBodyDto>
    export type ApiAdminPasswordResetMutationError = ErrorType<BackendErrorEntity>

    export const useApiAdminPasswordReset = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminPasswordReset>>, TError,{data: BodyType<AdminPasswordResetBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiAdminPasswordReset>>,
        TError,
        {data: BodyType<AdminPasswordResetBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiAdminPasswordResetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiAccountDirectSalesBuyer = (
    params?: MaybeRef<ApiAccountDirectSalesBuyerParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<AccountDirectSalesListingResponseDto>(
      {url: `/account/directSales/buyer`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiAccountDirectSalesBuyerQueryKey = (params?: MaybeRef<ApiAccountDirectSalesBuyerParams>,) => {
    return ['account','directSales','buyer', ...(params ? [params]: [])] as const;
    }

    
export const getApiAccountDirectSalesBuyerQueryOptions = <TData = Awaited<ReturnType<typeof apiAccountDirectSalesBuyer>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiAccountDirectSalesBuyerParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAccountDirectSalesBuyer>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiAccountDirectSalesBuyerQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountDirectSalesBuyer>>> = () => apiAccountDirectSalesBuyer(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAccountDirectSalesBuyer>>, TError, TData> 
}

export type ApiAccountDirectSalesBuyerQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountDirectSalesBuyer>>>
export type ApiAccountDirectSalesBuyerQueryError = ErrorType<BackendErrorEntity>



export function useApiAccountDirectSalesBuyer<TData = Awaited<ReturnType<typeof apiAccountDirectSalesBuyer>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiAccountDirectSalesBuyerParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAccountDirectSalesBuyer>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiAccountDirectSalesBuyerQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiAccountOrdersBuyer = (
    params?: MaybeRef<ApiAccountOrdersBuyerParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<AccountOrdersBuyerResponseDto>(
      {url: `/account/orders/buyer`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiAccountOrdersBuyerQueryKey = (params?: MaybeRef<ApiAccountOrdersBuyerParams>,) => {
    return ['account','orders','buyer', ...(params ? [params]: [])] as const;
    }

    
export const getApiAccountOrdersBuyerQueryOptions = <TData = Awaited<ReturnType<typeof apiAccountOrdersBuyer>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiAccountOrdersBuyerParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAccountOrdersBuyer>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiAccountOrdersBuyerQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountOrdersBuyer>>> = () => apiAccountOrdersBuyer(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAccountOrdersBuyer>>, TError, TData> 
}

export type ApiAccountOrdersBuyerQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountOrdersBuyer>>>
export type ApiAccountOrdersBuyerQueryError = ErrorType<BackendErrorEntity>



export function useApiAccountOrdersBuyer<TData = Awaited<ReturnType<typeof apiAccountOrdersBuyer>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiAccountOrdersBuyerParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAccountOrdersBuyer>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiAccountOrdersBuyerQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiUpdateAccountCompany = (
    updateAccountCompanyBodyDto: MaybeRef<UpdateAccountCompanyBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      updateAccountCompanyBodyDto = unref(updateAccountCompanyBodyDto);
      const formData = new FormData();
if(updateAccountCompanyBodyDto.operatorType !== undefined) {
 formData.append('operatorType', updateAccountCompanyBodyDto.operatorType)
 }
if(updateAccountCompanyBodyDto.companyRegistrationReportFile !== undefined && updateAccountCompanyBodyDto.companyRegistrationReportFile !== null) {
 formData.append('companyRegistrationReportFile', updateAccountCompanyBodyDto.companyRegistrationReportFile)
 }
if(updateAccountCompanyBodyDto.companyRegistrationReportIssueDate !== undefined && updateAccountCompanyBodyDto.companyRegistrationReportIssueDate !== null) {
 formData.append('companyRegistrationReportIssueDate', updateAccountCompanyBodyDto.companyRegistrationReportIssueDate)
 }

      return fetchApiInstance<UpdateAccountCompanyResponseDto>(
      {url: `/account/company`, method: 'PATCH',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getApiUpdateAccountCompanyMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateAccountCompany>>, TError,{data: BodyType<UpdateAccountCompanyBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUpdateAccountCompany>>, TError,{data: BodyType<UpdateAccountCompanyBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUpdateAccountCompany>>, {data: BodyType<UpdateAccountCompanyBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiUpdateAccountCompany(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUpdateAccountCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof apiUpdateAccountCompany>>>
    export type ApiUpdateAccountCompanyMutationBody = BodyType<UpdateAccountCompanyBodyDto>
    export type ApiUpdateAccountCompanyMutationError = ErrorType<BackendErrorEntity>

    export const useApiUpdateAccountCompany = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateAccountCompany>>, TError,{data: BodyType<UpdateAccountCompanyBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUpdateAccountCompany>>,
        TError,
        {data: BodyType<UpdateAccountCompanyBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiUpdateAccountCompanyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiUpdateAccount = (
    updateAccountBodyDto: MaybeRef<UpdateAccountBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      updateAccountBodyDto = unref(updateAccountBodyDto);
      
      return fetchApiInstance<UpdateAccountResponseDto>(
      {url: `/account`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateAccountBodyDto
    },
      options);
    }
  


export const getApiUpdateAccountMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateAccount>>, TError,{data: BodyType<UpdateAccountBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUpdateAccount>>, TError,{data: BodyType<UpdateAccountBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUpdateAccount>>, {data: BodyType<UpdateAccountBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiUpdateAccount(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUpdateAccountMutationResult = NonNullable<Awaited<ReturnType<typeof apiUpdateAccount>>>
    export type ApiUpdateAccountMutationBody = BodyType<UpdateAccountBodyDto>
    export type ApiUpdateAccountMutationError = ErrorType<BackendErrorEntity>

    export const useApiUpdateAccount = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateAccount>>, TError,{data: BodyType<UpdateAccountBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUpdateAccount>>,
        TError,
        {data: BodyType<UpdateAccountBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiUpdateAccountMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiCompleteOnboardingSession = (
    completeOnboardingSessionBodyDto: MaybeRef<CompleteOnboardingSessionBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      completeOnboardingSessionBodyDto = unref(completeOnboardingSessionBodyDto);
      
      return fetchApiInstance<CompleteOnboardingSessionResponseDto>(
      {url: `/account/completeOnboardingSession`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: completeOnboardingSessionBodyDto
    },
      options);
    }
  


export const getApiCompleteOnboardingSessionMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCompleteOnboardingSession>>, TError,{data: BodyType<CompleteOnboardingSessionBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiCompleteOnboardingSession>>, TError,{data: BodyType<CompleteOnboardingSessionBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiCompleteOnboardingSession>>, {data: BodyType<CompleteOnboardingSessionBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiCompleteOnboardingSession(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiCompleteOnboardingSessionMutationResult = NonNullable<Awaited<ReturnType<typeof apiCompleteOnboardingSession>>>
    export type ApiCompleteOnboardingSessionMutationBody = BodyType<CompleteOnboardingSessionBodyDto>
    export type ApiCompleteOnboardingSessionMutationError = ErrorType<BackendErrorEntity>

    export const useApiCompleteOnboardingSession = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCompleteOnboardingSession>>, TError,{data: BodyType<CompleteOnboardingSessionBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiCompleteOnboardingSession>>,
        TError,
        {data: BodyType<CompleteOnboardingSessionBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiCompleteOnboardingSessionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiAccountExist = (
    params: MaybeRef<ApiAccountExistParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<AccountExistResponseDto>(
      {url: `/account/exist`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiAccountExistQueryKey = (params: MaybeRef<ApiAccountExistParams>,) => {
    return ['account','exist', ...(params ? [params]: [])] as const;
    }

    
export const getApiAccountExistQueryOptions = <TData = Awaited<ReturnType<typeof apiAccountExist>>, TError = ErrorType<BackendErrorEntity>>(params: MaybeRef<ApiAccountExistParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAccountExist>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiAccountExistQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountExist>>> = () => apiAccountExist(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAccountExist>>, TError, TData> 
}

export type ApiAccountExistQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountExist>>>
export type ApiAccountExistQueryError = ErrorType<BackendErrorEntity>



export function useApiAccountExist<TData = Awaited<ReturnType<typeof apiAccountExist>>, TError = ErrorType<BackendErrorEntity>>(
 params: MaybeRef<ApiAccountExistParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAccountExist>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiAccountExistQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiAccountAuctionsBuyer = (
    params?: MaybeRef<ApiAccountAuctionsBuyerParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<AuctionsListingResponseDto>(
      {url: `/account/auctions/buyer`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiAccountAuctionsBuyerQueryKey = (params?: MaybeRef<ApiAccountAuctionsBuyerParams>,) => {
    return ['account','auctions','buyer', ...(params ? [params]: [])] as const;
    }

    
export const getApiAccountAuctionsBuyerQueryOptions = <TData = Awaited<ReturnType<typeof apiAccountAuctionsBuyer>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiAccountAuctionsBuyerParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAccountAuctionsBuyer>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiAccountAuctionsBuyerQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountAuctionsBuyer>>> = () => apiAccountAuctionsBuyer(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAccountAuctionsBuyer>>, TError, TData> 
}

export type ApiAccountAuctionsBuyerQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountAuctionsBuyer>>>
export type ApiAccountAuctionsBuyerQueryError = ErrorType<BackendErrorEntity>



export function useApiAccountAuctionsBuyer<TData = Awaited<ReturnType<typeof apiAccountAuctionsBuyer>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiAccountAuctionsBuyerParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAccountAuctionsBuyer>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiAccountAuctionsBuyerQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiAccountAuctionsSeller = (
    params?: MaybeRef<ApiAccountAuctionsSellerParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<AuctionsListingResponseDto>(
      {url: `/account/auctions/seller`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiAccountAuctionsSellerQueryKey = (params?: MaybeRef<ApiAccountAuctionsSellerParams>,) => {
    return ['account','auctions','seller', ...(params ? [params]: [])] as const;
    }

    
export const getApiAccountAuctionsSellerQueryOptions = <TData = Awaited<ReturnType<typeof apiAccountAuctionsSeller>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiAccountAuctionsSellerParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAccountAuctionsSeller>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiAccountAuctionsSellerQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountAuctionsSeller>>> = () => apiAccountAuctionsSeller(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAccountAuctionsSeller>>, TError, TData> 
}

export type ApiAccountAuctionsSellerQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountAuctionsSeller>>>
export type ApiAccountAuctionsSellerQueryError = ErrorType<BackendErrorEntity>



export function useApiAccountAuctionsSeller<TData = Awaited<ReturnType<typeof apiAccountAuctionsSeller>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiAccountAuctionsSellerParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAccountAuctionsSeller>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiAccountAuctionsSellerQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiAccountDirectSalesSeller = (
    params?: MaybeRef<ApiAccountDirectSalesSellerParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<DirectSalesListingResponseDto>(
      {url: `/account/directSales/seller`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiAccountDirectSalesSellerQueryKey = (params?: MaybeRef<ApiAccountDirectSalesSellerParams>,) => {
    return ['account','directSales','seller', ...(params ? [params]: [])] as const;
    }

    
export const getApiAccountDirectSalesSellerQueryOptions = <TData = Awaited<ReturnType<typeof apiAccountDirectSalesSeller>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiAccountDirectSalesSellerParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAccountDirectSalesSeller>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiAccountDirectSalesSellerQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountDirectSalesSeller>>> = () => apiAccountDirectSalesSeller(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAccountDirectSalesSeller>>, TError, TData> 
}

export type ApiAccountDirectSalesSellerQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountDirectSalesSeller>>>
export type ApiAccountDirectSalesSellerQueryError = ErrorType<BackendErrorEntity>



export function useApiAccountDirectSalesSeller<TData = Awaited<ReturnType<typeof apiAccountDirectSalesSeller>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiAccountDirectSalesSellerParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAccountDirectSalesSeller>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiAccountDirectSalesSellerQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



